import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormGroup,
  TextField,
} from '@mui/material';
import { useState, useEffect } from 'react';

interface StartJobDialogProps {
  open: boolean;
  onClose: () => void;
  onStart: (limit?: number) => void;
}

export const StartJobDialog = ({
  open,
  onClose,
  onStart,
}: StartJobDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [limit, setLimit] = useState<string>('');
  const [limitError, setLimitError] = useState<string>('');
  // const [dryRun, setDryRun] = useState<boolean>(false);

  useEffect(() => {
    setIsSubmitting(false);
    setLimit('');
    setLimitError('');
    //setDryRun(false);
  }, [open]);

  const validateLimit = (value: string): boolean => {
    if (value === '') {
      setLimitError('');
      return true;
    }

    const numValue = Number(value);
    if (isNaN(numValue)) {
      setLimitError('Please enter a valid number');
      return false;
    }

    if (numValue <= 0) {
      setLimitError('Limit must be a positive number');
      return false;
    }

    setLimitError('');
    return true;
  };

  const handleLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLimit(value);
    validateLimit(value);
  };

  const handleSubmit = () => {
    if (limit && !validateLimit(limit)) {
      return;
    }

    setIsSubmitting(true);
    onStart(limit ? Number(limit) : undefined);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { width: '400px' } }}
    >
      <DialogTitle>Start Typesense Sync Job</DialogTitle>
      <DialogContent>
        <FormGroup>
          <>
            <TextField
              margin="normal"
              fullWidth
              label="Products limit (optional)"
              type="number"
              value={limit}
              onChange={handleLimitChange}
              error={!!limitError}
              helperText={limitError}
              InputProps={{
                inputProps: {
                  min: 1,
                  step: 1,
                  inputMode: 'numeric',
                },
              }}
            />
            {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={dryRun}
                    onChange={(e) => setDryRun(e.target.checked)}
                  />
                }
                label="Dry run (no Supabase update)"
              /> */}
          </>
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isSubmitting || !!limitError}
        >
          {isSubmitting ? 'Processing...' : 'Start'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
